/**
 * The Picklr Theme JavaScript - Production Clean
 */

// ============================================================
// 1. REAL-TIME CAD / USD CURRENCY CONVERTER
// ============================================================
const CAD_TO_USD_RATE = 0.74; // 1 CAD = 0.74 USD

function getActiveCurrency() {
  return localStorage.getItem('picklr_currency') || 'CAD';
}

function formatCurrencyString(baseCadPrice, currency) {
  if (isNaN(baseCadPrice)) return '';
  if (currency === 'USD') {
    return '$' + (baseCadPrice * CAD_TO_USD_RATE).toFixed(2) + ' USD';
  }
  return '$' + baseCadPrice.toFixed(2) + ' CAD';
}

function convertAllPrices(targetCurrency) {
  localStorage.setItem('picklr_currency', targetCurrency);

  // Update active header label
  const activeLabel = document.getElementById('ActiveCurrencyCode');
  if (activeLabel) {
    activeLabel.textContent = targetCurrency + ' $';
  }

  // Update desktop dropdown active state
  document.querySelectorAll('.currency-option').forEach(btn => {
    if (btn.getAttribute('data-currency') === targetCurrency) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  // Update mobile drawer currency pills
  document.querySelectorAll('.mobile-curr-btn').forEach(btn => {
    if (btn.getAttribute('data-currency') === targetCurrency) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  // Convert all price elements on the page
  document.querySelectorAll('.money-price, [data-base-price]').forEach(el => {
    let basePrice = parseFloat(el.getAttribute('data-base-price'));
    if (isNaN(basePrice)) {
      // Extract numbers from text if data-base-price not present
      const match = el.textContent.replace(/,/g, '').match(/[\d]+(\.[\d]+)?/);
      if (match) {
        basePrice = parseFloat(match[0]);
        el.setAttribute('data-base-price', basePrice.toFixed(2));
      }
    }
    if (!isNaN(basePrice)) {
      el.textContent = formatCurrencyString(basePrice, targetCurrency);
    }
  });

  // Re-calculate cart subtotal if present
  const subtotalEl = document.getElementById('CartSubtotal');
  if (subtotalEl) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const totalCad = cart.total_price / 100;
        subtotalEl.textContent = formatCurrencyString(totalCad, targetCurrency);
      })
      .catch(() => {});
  }
}

window.setCurrency = convertAllPrices;
window.formatCurrencyString = formatCurrencyString;

// ============================================================
// 2. GLOBAL CART REFRESH & DRAWER BUILDER
// ============================================================
window.refreshPicklrCart = function() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const activeCurr = getActiveCurrency();

      // Update header badge
      const badges = document.querySelectorAll('#CartBadge, .cart-badge');
      badges.forEach(b => {
        b.innerHTML = `<span style="display:block;transform:rotate(-15deg);">${cart.item_count || 0}</span>`;
        b.style.display = 'flex';
      });

      // Update Subtotal & Checkout Total
      const cartSubtotal = document.getElementById('CartSubtotal');
      const checkoutTotal = document.getElementById('CartCheckoutTotal');
      const totalCad = cart.total_price / 100;
      const formattedTotal = formatCurrencyString(totalCad, activeCurr);
      if (cartSubtotal) {
        cartSubtotal.textContent = formattedTotal;
      }
      if (checkoutTotal) {
        checkoutTotal.textContent = formattedTotal;
      }

      // Update Footer visibility
      const cartFooter = document.getElementById('CartFooter');
      if (cartFooter) {
        cartFooter.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }

      // Rebuild Cart Items HTML
      const cartBody = document.getElementById('CartBody');
      if (cartBody) {
        if (cart.item_count === 0) {
          cartBody.innerHTML = '<div class="pcd-empty" id="CartEmpty"><p>Your cart is empty.</p><button type="button" class="pcd-keep-shopping" onclick="closeCartDrawer()">KEEP SHOPPING</button></div>';
        } else {
          let itemsHtml = '<div id="CartItemsList">';
          cart.items.forEach((item, idx) => {
            const lineNum = idx + 1;
            const imgUrl = item.image ? item.image : '';
            const variantText = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="pcd-item-variant">' + item.variant_title + '</p>' : '';
            const itemPriceCad = item.final_line_price / 100;
            const priceText = formatCurrencyString(itemPriceCad, activeCurr);

            itemsHtml += `
              <div class="pcd-item" data-line="${lineNum}">
                <div class="pcd-item-img">
                  ${imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.product_title || item.title) + '" loading="lazy">' : '<div class="pcd-item-img-blank"></div>'}
                </div>
                <div class="pcd-item-right">
                  <div class="pcd-item-header-row">
                    <h4 class="pcd-item-name">${item.product_title || item.title}</h4>
                    <p class="pcd-item-price" data-base-price="${itemPriceCad}">${priceText}</p>
                  </div>
                  ${variantText}
                  <div class="pcd-item-controls">
                    <div class="pcd-stepper">
                      <button type="button" class="pcd-step-btn" data-action="dec" data-line="${lineNum}">&#8722;</button>
                      <span class="pcd-step-qty">${item.quantity}</span>
                      <button type="button" class="pcd-step-btn" data-action="inc" data-line="${lineNum}">&#43;</button>
                    </div>
                    <button type="button" class="pcd-remove-btn" data-action="del" data-line="${lineNum}" title="Remove item" aria-label="Remove item">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ee3b45" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            `;
          });
          itemsHtml += '</div>';
          cartBody.innerHTML = itemsHtml;
          
          bindCartStepperButtons();
        }
      }
    })
    .catch(err => console.error('Error refreshing cart:', err));
};

function bindCartStepperButtons() {
  document.querySelectorAll('.pcd-step-btn, .pcd-remove-btn').forEach(btn => {
    btn.onclick = function(e) {
      e.preventDefault();
      const line = parseInt(this.getAttribute('data-line'), 10);
      const action = this.getAttribute('data-action');
      const qtySpan = this.parentElement ? this.parentElement.querySelector('.pcd-step-qty') : null;
      let currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;

      let newQty = currentQty;
      if (action === 'inc') newQty = currentQty + 1;
      if (action === 'dec') newQty = Math.max(0, currentQty - 1);
      if (action === 'del') newQty = 0;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
      .then(res => res.json())
      .then(() => {
        window.refreshPicklrCart();
      })
      .catch(err => console.error('Cart update error:', err));
    };
  });
}

window.pcdBindCartButtons = bindCartStepperButtons;

// ============================================================
// 3. DOM READY INITIALIZATION
// ============================================================
document.addEventListener('DOMContentLoaded', () => {

  // --- Sticky Header Background on Scroll ---
  const header = document.querySelector('.site-header');
  if (header) {
    function updateHeaderScroll() {
      const scrollPos = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollPos > 30) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    // Run immediately on load so header is correct if page reloads while scrolled down
    updateHeaderScroll();
    window.addEventListener('scroll', updateHeaderScroll, { passive: true });
  }

  // --- Currency Selector Dropdown & Mobile Toggle ---
  const currToggleBtn = document.getElementById('CurrencyToggleBtn');
  const currDropdown = document.getElementById('CurrencyDropdown');

  if (currToggleBtn && currDropdown) {
    currToggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      currDropdown.classList.toggle('active');
    });

    document.addEventListener('click', () => {
      currDropdown.classList.remove('active');
    });
  }

  document.querySelectorAll('.currency-option, .mobile-curr-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const curr = this.getAttribute('data-currency');
      convertAllPrices(curr);
      if (currDropdown) currDropdown.classList.remove('active');
      if (window.showPicklrToast) {
        window.showPicklrToast('CURRENCY UPDATED', 'Store currency set to ' + curr + ' $');
      }
    });
  });

  // Restore saved currency on page load
  const initialCurrency = getActiveCurrency();
  convertAllPrices(initialCurrency);

  // --- Mobile Navigation Drawer ---
  const mobileToggleBtn = document.getElementById('MobileNavToggle');
  const mobileDrawer = document.getElementById('MobileNavDrawer');
  const mobileOverlay = document.getElementById('MobileNavOverlay');
  const mobileCloseBtn = document.getElementById('MobileNavClose');

  function openMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (mobileToggleBtn) mobileToggleBtn.addEventListener('click', openMobileMenu);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // --- Cart Drawer Open / Close ---
  const drawerOverlay = document.getElementById('CartDrawerOverlay');
  const drawerEl = document.getElementById('CartDrawer');
  const drawerCloseBtn = document.getElementById('CartDrawerClose');
  const cartIconToggles = document.querySelectorAll('#CartIconToggle, .cart-icon-wrapper');

  function openCartDrawer() {
    if (drawerEl) drawerEl.classList.add('active');
    if (drawerOverlay) drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    window.refreshPicklrCart();
  }

  function closeCartDrawer() {
    if (drawerEl) drawerEl.classList.remove('active');
    if (drawerOverlay) drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  cartIconToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeCartDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeCartDrawer);

  // --- Cart Drawer Note Accordion & Save ---
  const noteToggleBtn = document.getElementById('NoteToggleBtn');
  const notePanel = document.getElementById('NotePanel');
  const noteSaveBtn = document.getElementById('NoteSaveBtn');
  const cartNoteInput = document.getElementById('CartNoteInput');
  const noteFeedback = document.getElementById('NoteFeedback');

  if (noteToggleBtn && notePanel) {
    noteToggleBtn.addEventListener('click', () => {
      const isExpanded = noteToggleBtn.getAttribute('aria-expanded') === 'true';
      noteToggleBtn.setAttribute('aria-expanded', !isExpanded);
      notePanel.classList.toggle('open');
    });
  }

  if (noteSaveBtn && cartNoteInput) {
    noteSaveBtn.addEventListener('click', () => {
      noteSaveBtn.disabled = true;
      noteSaveBtn.textContent = 'SAVING...';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: cartNoteInput.value })
      })
      .then(res => res.json())
      .then(() => {
        noteSaveBtn.disabled = false;
        noteSaveBtn.textContent = 'SAVE NOTE';
        if (noteFeedback) {
          noteFeedback.textContent = 'Note saved successfully!';
          noteFeedback.className = 'pcd-feedback ok';
          setTimeout(() => { noteFeedback.textContent = ''; }, 3000);
        }
      })
      .catch(() => {
        noteSaveBtn.disabled = false;
        noteSaveBtn.textContent = 'SAVE NOTE';
        if (noteFeedback) {
          noteFeedback.textContent = 'Failed to save note.';
          noteFeedback.className = 'pcd-feedback err';
        }
      });
    });
  }

  // --- Cart Drawer Discount Code Accordion & Checkout Link ---
  const discountToggleBtn = document.getElementById('DiscountToggleBtn');
  const discountPanel = document.getElementById('DiscountPanel');
  const discountInput = document.getElementById('DiscountInput');
  const discountApplyBtn = document.getElementById('DiscountApplyBtn');
  const discountTag = document.getElementById('DiscountTag');
  const discountFeedback = document.getElementById('DiscountFeedback');
  const cartCheckoutBtn = document.getElementById('CartCheckoutBtn');

  let savedDiscount = sessionStorage.getItem('picklr_discount_code') || '';

  function renderDiscountTag() {
    if (!discountTag) return;
    if (savedDiscount) {
      discountTag.innerHTML = `
        <span class="pcd-discount-tag">
          <span>${savedDiscount}</span>
          <button type="button" class="pcd-discount-tag-remove" id="RemoveDiscountBtn" aria-label="Remove discount">&times;</button>
        </span>
      `;
      const removeBtn = document.getElementById('RemoveDiscountBtn');
      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          savedDiscount = '';
          sessionStorage.removeItem('picklr_discount_code');
          renderDiscountTag();
          if (discountFeedback) discountFeedback.textContent = '';
        });
      }
    } else {
      discountTag.innerHTML = '';
    }
  }

  renderDiscountTag();

  if (discountToggleBtn && discountPanel) {
    discountToggleBtn.addEventListener('click', () => {
      const isExpanded = discountToggleBtn.getAttribute('aria-expanded') === 'true';
      discountToggleBtn.setAttribute('aria-expanded', !isExpanded);
      discountPanel.classList.toggle('open');
    });
  }

  if (discountApplyBtn && discountInput) {
    discountApplyBtn.addEventListener('click', () => {
      const code = discountInput.value.trim();
      if (!code) return;
      savedDiscount = code;
      sessionStorage.setItem('picklr_discount_code', code);
      renderDiscountTag();
      discountInput.value = '';
      if (discountFeedback) {
        discountFeedback.textContent = `Discount '${code}' will be applied at checkout!`;
        discountFeedback.className = 'pcd-feedback ok';
      }
    });
  }

  if (cartCheckoutBtn) {
    cartCheckoutBtn.addEventListener('click', () => {
      let checkoutUrl = '/checkout';
      if (savedDiscount) {
        checkoutUrl += '?discount=' + encodeURIComponent(savedDiscount);
      }
      window.location.href = checkoutUrl;
    });
  }

  // --- Hero Slideshow Controller ---
  document.querySelectorAll('.slideshow-container').forEach(container => {
    const slides = container.querySelectorAll('.slideshow-slide');
    const dots = container.querySelectorAll('.slideshow-dot');
    const track = container.querySelector('.slideshow-track');
    let currentIndex = 0;
    let timer = null;

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;

      slides.forEach((slide, i) => {
        if (i === currentIndex) {
          slide.classList.add('active', 'is-selected');
          const video = slide.querySelector('video');
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        } else {
          slide.classList.remove('active', 'is-selected');
          const video = slide.querySelector('video');
          if (video) {
            video.pause();
          }
        }
      });

      dots.forEach((dot, i) => {
        if (i === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(i);
        resetTimer();
      });
    });

    const isAutoplay = track && track.dataset.autoplay === 'true';
    const speed = track && track.dataset.speed ? parseInt(track.dataset.speed, 10) * 1000 : 5000;

    function startTimer() {
      if (isAutoplay && slides.length > 1) {
        timer = setInterval(() => {
          goToSlide(currentIndex + 1);
        }, speed);
      }
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      startTimer();
    }

    startTimer();
  });

  // --- Toast Notification Helper ---
  window.showPicklrToast = function(title, message) {
    let toast = document.getElementById('ToastNotification');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ToastNotification';
      toast.className = 'toast-notification';
      toast.innerHTML = '<div class="toast-content"><div class="toast-title" id="ToastTitle"></div><div class="toast-message" id="ToastMessage"></div></div>';
      document.body.appendChild(toast);
    }
    const tTitle = document.getElementById('ToastTitle');
    const tMsg = document.getElementById('ToastMessage');
    if (tTitle) tTitle.textContent = title;
    if (tMsg) tMsg.textContent = message;

    toast.classList.add('active');
    setTimeout(() => {
      toast.classList.remove('active');
    }, 3500);
  };

  // --- AJAX Add to Cart & Buy Now Handlers for all product forms ---
  document.querySelectorAll('form[action*="/cart/add"], #product-form').forEach(productForm => {
    productForm.addEventListener('submit', function(e) {
      const submitter = e.submitter;
      const isBuyNow = submitter && (submitter.name === 'checkout' || submitter.id.includes('BuyNow'));

      if (isBuyNow) {
        // Direct checkout
        return;
      }

      e.preventDefault();
      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(item => {
        window.showPicklrToast('ADDED TO BAG', (item.title || 'Item') + ' was added to your cart.');
        openCartDrawer();
      })
      .catch(err => {
        console.error('AJAX add error:', err);
        productForm.submit();
      });
    });
  });

  // --- Search Modal Toggle ---
  const searchToggleBtns = document.querySelectorAll('.search-toggle');
  const searchOverlay = document.getElementById('SearchOverlay') || document.getElementById('SearchModalOverlay');
  const searchCloseBtns = document.querySelectorAll('#SearchCloseBtn, #SearchModalClose');
  const searchInput = document.querySelector('.search-input, .search-modal-input');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('active');
      if (searchInput) setTimeout(() => searchInput.focus(), 150);
    }
  }

  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('active');
  }

  searchToggleBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openSearch(); }));
  searchCloseBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); closeSearch(); }));
  if (searchOverlay) {
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  // --- Product Card Multi-Image Hover / Cursor Scrubber ---
  function initProductCardHoverScrubbing() {
    const cards = document.querySelectorAll(
      '.interactive-hover-media, .hover-image-card, .product-card-media-wrapper, .card-item'
    );

    cards.forEach(card => {
      if (card.dataset.hoverScrubBound === 'true') return;

      const mediaWrapper = card.classList.contains('interactive-hover-media') || card.classList.contains('product-card-media-wrapper')
        ? card
        : card.querySelector('.interactive-hover-media, .product-card-media-wrapper, .card-media-wrapper');

      if (!mediaWrapper) return;

      const images = mediaWrapper.querySelectorAll('.multi-img, .product-card-image, img.card-media');
      if (images.length <= 1) return;

      card.dataset.hoverScrubBound = 'true';

      const dots = card.querySelectorAll('.card-dot');

      function setActiveImage(index) {
        if (index < 0) index = 0;
        if (index >= images.length) index = images.length - 1;

        images.forEach((img, i) => {
          const imgIndex = parseInt(img.getAttribute('data-index'), 10);
          const effectiveIndex = isNaN(imgIndex) ? i : imgIndex;
          if (effectiveIndex === index) {
            img.classList.add('active');
          } else {
            img.classList.remove('active');
          }
        });

        if (dots.length > 0) {
          dots.forEach((dot, i) => {
            const dotIndex = parseInt(dot.getAttribute('data-index'), 10);
            const effectiveIndex = isNaN(dotIndex) ? i : dotIndex;
            if (effectiveIndex === index) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      }

      function handleMove(e) {
        const rect = mediaWrapper.getBoundingClientRect();
        const clientX = e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
        const x = clientX - rect.left;
        const width = rect.width;
        if (width <= 0) return;

        const progress = Math.max(0, Math.min(0.9999, x / width));
        const targetIndex = Math.floor(progress * images.length);
        setActiveImage(targetIndex);
      }

      function handleLeave() {
        setActiveImage(0);
      }

      mediaWrapper.addEventListener('mousemove', handleMove, { passive: true });
      mediaWrapper.addEventListener('mouseleave', handleLeave, { passive: true });

      if (card !== mediaWrapper) {
        card.addEventListener('mouseleave', handleLeave, { passive: true });
      }

      mediaWrapper.addEventListener('touchmove', handleMove, { passive: true });
    });
  }

  window.initProductCardHoverScrubbing = initProductCardHoverScrubbing;

  // Initialize Product Card Hover Scrubbing
  initProductCardHoverScrubbing();

  // --- Filter & Sort Slide-Out Drawer Controller ---
  function initFilterAndSortDrawer() {
    const drawer = document.getElementById('FilterDrawer');
    const overlay = document.getElementById('FilterDrawerOverlay');
    const closeBtn = document.getElementById('FilterDrawerClose');
    const openBtns = document.querySelectorAll('.filter-sort-btn');
    const applyBtn = document.getElementById('ApplyFiltersBtn');
    const resetBtn = document.getElementById('ResetFiltersBtn');

    if (!drawer) return;

    function openFilterDrawer() {
      drawer.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      drawer.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    openBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openFilterDrawer();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeFilterDrawer);
    if (overlay) overlay.addEventListener('click', closeFilterDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('active')) {
        closeFilterDrawer();
      }
    });

    // --- Price Range Slider Logic ---
    const rangeMin = document.getElementById('PriceRangeMin');
    const rangeMax = document.getElementById('PriceRangeMax');
    const inputMin = document.getElementById('PriceInputMin');
    const inputMax = document.getElementById('PriceInputMax');
    const progressTrack = document.getElementById('PriceSliderProgress');
    const priceReadout = document.getElementById('FilterPriceReadout');
    const maxScaleLimit = 400;

    function updatePriceSliderUI(minVal, maxVal) {
      if (!rangeMin || !rangeMax) return;
      const minPercent = Math.min(100, Math.max(0, (minVal / maxScaleLimit) * 100));
      const maxPercent = Math.min(100, Math.max(0, (maxVal / maxScaleLimit) * 100));

      if (progressTrack) {
        progressTrack.style.left = minPercent + '%';
        progressTrack.style.width = (maxPercent - minPercent) + '%';
      }

      if (priceReadout) {
        const maxText = maxVal >= maxScaleLimit ? `$${maxScaleLimit}+` : `$${maxVal}`;
        priceReadout.textContent = `$${minVal} — ${maxText}`;
      }

      if (rangeMin) rangeMin.value = minVal;
      if (rangeMax) rangeMax.value = maxVal;
      if (inputMin) inputMin.value = minVal;
      if (inputMax) inputMax.value = maxVal;
    }

    if (rangeMin && rangeMax) {
      rangeMin.addEventListener('input', () => {
        let minV = parseInt(rangeMin.value, 10) || 0;
        let maxV = parseInt(rangeMax.value, 10) || maxScaleLimit;
        if (minV > maxV - 5) {
          minV = maxV - 5;
          rangeMin.value = minV;
        }
        updatePriceSliderUI(minV, maxV);
      });

      rangeMax.addEventListener('input', () => {
        let minV = parseInt(rangeMin.value, 10) || 0;
        let maxV = parseInt(rangeMax.value, 10) || maxScaleLimit;
        if (maxV < minV + 5) {
          maxV = minV + 5;
          rangeMax.value = maxV;
        }
        updatePriceSliderUI(minV, maxV);
      });
    }

    if (inputMin && inputMax) {
      inputMin.addEventListener('change', () => {
        let minV = parseInt(inputMin.value, 10) || 0;
        let maxV = parseInt(inputMax.value, 10) || maxScaleLimit;
        minV = Math.max(0, Math.min(minV, maxV - 5));
        updatePriceSliderUI(minV, maxV);
      });

      inputMax.addEventListener('change', () => {
        let minV = parseInt(inputMin.value, 10) || 0;
        let maxV = parseInt(inputMax.value, 10) || maxScaleLimit;
        maxV = Math.min(maxScaleLimit, Math.max(maxV, minV + 5));
        updatePriceSliderUI(minV, maxV);
      });
    }

    // --- Conditional Paddle Specifications Visibility ---
    function updatePaddleSpecVisibility() {
      const paddleCheckbox = document.querySelector('.category-filter-checkbox[value="paddles"]');
      const paddleSpecGroup = document.getElementById('PaddleSpecFilterGroup');
      if (!paddleSpecGroup) return;

      if (paddleCheckbox && paddleCheckbox.checked) {
        paddleSpecGroup.style.display = 'block';
      } else {
        paddleSpecGroup.style.display = 'none';
      }
    }

    const categoryCheckboxes = document.querySelectorAll('.category-filter-checkbox');
    categoryCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        updatePaddleSpecVisibility();
      });
    });

    // Run visibility check on initial load
    updatePaddleSpecVisibility();

    const inlineSort = document.getElementById('CollectionInlineSort');
    if (inlineSort) {
      inlineSort.addEventListener('change', () => {
        applyFilterAndSort();
      });
    }

    function applyFilterAndSort() {
      const grid = document.querySelector('.grid-cards');
      if (!grid) {
        closeFilterDrawer();
        return;
      }

      const cards = Array.from(grid.querySelectorAll('.card-item'));
      if (!cards.length) {
        closeFilterDrawer();
        return;
      }

      cards.forEach((card, idx) => {
        if (card.dataset.initialIndex === undefined) {
          card.dataset.initialIndex = idx;
        }
      });

      const inlineSort = document.getElementById('CollectionInlineSort');
      const sortValue = (inlineSort && inlineSort.value) || 'featured';

      // 1. Category Filter
      const checkedCategories = Array.from(document.querySelectorAll('.category-filter-checkbox:checked')).map(cb => cb.value.toLowerCase());
      const filterByCategory = checkedCategories.length > 0 && checkedCategories.length < categoryCheckboxes.length;
      const paddleCheckbox = document.querySelector('.category-filter-checkbox[value="paddles"]');
      const isPaddleCategoryActive = !paddleCheckbox || paddleCheckbox.checked;

      // 2. In-Stock Filter
      const inStockCheckbox = document.getElementById('instock-only-checkbox');
      const filterInStockOnly = inStockCheckbox ? inStockCheckbox.checked : false;

      // 3. Price Filter
      const minPriceSelected = rangeMin ? parseFloat(rangeMin.value) : 0;
      const maxPriceSelected = rangeMax ? parseFloat(rangeMax.value) : maxScaleLimit;
      const filterByPrice = minPriceSelected > 0 || maxPriceSelected < maxScaleLimit;

      // 4. Paddle Core Thickness Filter (14mm, 16mm) - Active only if Paddles category is checked
      const checkedCores = isPaddleCategoryActive ? Array.from(document.querySelectorAll('.paddle-core-checkbox:checked')).map(cb => cb.value.toLowerCase()) : [];
      const filterByCore = checkedCores.length > 0;

      // 5. Paddle Shape Filter (elongated, hybrid, wide body) - Active only if Paddles category is checked
      const checkedShapes = isPaddleCategoryActive ? Array.from(document.querySelectorAll('.paddle-shape-checkbox:checked')).map(cb => cb.value.toLowerCase()) : [];
      const filterByShape = checkedShapes.length > 0;

      // 6. Paddle Vendor / Brand Filter - Active only if Paddles category is checked
      const checkedVendors = isPaddleCategoryActive ? Array.from(document.querySelectorAll('.paddle-vendor-checkbox:checked')).map(cb => cb.value.toLowerCase()) : [];
      const filterByVendor = checkedVendors.length > 0;

      let visibleCards = [];
      cards.forEach(card => {
        const title = (card.dataset.title || card.querySelector('.card-title')?.textContent || '').toLowerCase();
        const type = (card.dataset.type || '').toLowerCase();
        const tags = (card.dataset.tags || '').toLowerCase();
        const vendor = (card.dataset.vendor || '').toLowerCase();
        const options = (card.dataset.options || '').toLowerCase();
        const categoryText = (card.querySelector('.card-category')?.textContent || '').toLowerCase();
        const available = card.dataset.available !== 'false';
        const price = parseFloat(card.dataset.price || card.querySelector('[data-base-price]')?.getAttribute('data-base-price') || '0');

        // Check Category
        let matchesCategory = true;
        if (filterByCategory) {
          matchesCategory = checkedCategories.some(cat => {
            return title.includes(cat) || type.includes(cat) || tags.includes(cat) || categoryText.includes(cat);
          });
        }

        // Check Stock
        let matchesStock = true;
        if (filterInStockOnly) {
          matchesStock = available;
        }

        // Check Price
        let matchesPrice = true;
        if (filterByPrice) {
          if (price < minPriceSelected) matchesPrice = false;
          if (maxPriceSelected < maxScaleLimit && price > maxPriceSelected) matchesPrice = false;
        }

        // Check Paddle Core Thickness
        let matchesCore = true;
        if (filterByCore) {
          matchesCore = checkedCores.some(core => {
            return tags.includes(core) || title.includes(core) || options.includes(core);
          });
        }

        // Check Paddle Shape
        let matchesShape = true;
        if (filterByShape) {
          matchesShape = checkedShapes.some(shape => {
            if (shape === 'wide body') {
              return tags.includes('wide body') || tags.includes('wide-body') || tags.includes('widebody') ||
                     title.includes('wide body') || title.includes('wide-body') || title.includes('widebody') ||
                     options.includes('wide body') || options.includes('wide-body') || options.includes('widebody');
            }
            return tags.includes(shape) || title.includes(shape) || options.includes(shape);
          });
        }

        // Check Paddle Vendor / Brand
        let matchesVendor = true;
        if (filterByVendor) {
          matchesVendor = checkedVendors.some(brand => {
            const cleanBrand = brand.replace(/[-_ ]/g, '');
            const cleanVendor = vendor.replace(/[-_ ]/g, '');
            const cleanTitle = title.replace(/[-_ ]/g, '');
            const cleanTags = tags.replace(/[-_ ]/g, '');
            return cleanVendor.includes(cleanBrand) || cleanTitle.includes(cleanBrand) || cleanTags.includes(cleanBrand);
          });
        }

        if (matchesCategory && matchesStock && matchesPrice && matchesCore && matchesShape && matchesVendor) {
          card.style.display = '';
          visibleCards.push(card);
        } else {
          card.style.display = 'none';
        }
      });

      visibleCards.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price || a.querySelector('[data-base-price]')?.getAttribute('data-base-price') || '0');
        const priceB = parseFloat(b.dataset.price || b.querySelector('[data-base-price]')?.getAttribute('data-base-price') || '0');
        const titleA = (a.dataset.title || a.querySelector('.card-title')?.textContent || '').toLowerCase();
        const titleB = (b.dataset.title || b.querySelector('.card-title')?.textContent || '').toLowerCase();
        const indexA = parseInt(a.dataset.initialIndex, 10) || 0;
        const indexB = parseInt(b.dataset.initialIndex, 10) || 0;

        if (sortValue === 'price-low-high') return priceA - priceB;
        if (sortValue === 'price-high-low') return priceB - priceA;
        if (sortValue === 'title-asc') return titleA.localeCompare(titleB);
        if (sortValue === 'title-desc') return titleB.localeCompare(titleA);
        return indexA - indexB;
      });

      visibleCards.forEach(card => grid.appendChild(card));

      const countBadge = document.querySelector('.collection-product-count, #ProductCount, .thb-filter-count');
      if (countBadge) {
        countBadge.textContent = visibleCards.length + (visibleCards.length === 1 ? ' PRODUCT' : ' PRODUCTS');
      }

      let emptyMessage = document.getElementById('NoFilterResults');
      if (visibleCards.length === 0) {
        if (!emptyMessage) {
          emptyMessage = document.createElement('div');
          emptyMessage.id = 'NoFilterResults';
          emptyMessage.style.cssText = 'grid-column: 1 / -1; text-align: center; padding: 4rem 1rem; color: #a1a1aa; font-family: var(--font-body);';
          emptyMessage.innerHTML = '<h3 style="font-family: var(--font-heading); color: #fff; font-size: 1.5rem; margin-bottom: 0.5rem; text-transform: uppercase;">No Products Found</h3><p style="font-size: 0.95rem;">No products match the selected filters. Try adjusting or resetting your filters.</p>';
          grid.appendChild(emptyMessage);
        }
        emptyMessage.style.display = 'block';
      } else if (emptyMessage) {
        emptyMessage.style.display = 'none';
      }

      if (window.initProductCardHoverScrubbing) {
        window.initProductCardHoverScrubbing();
      }

      closeFilterDrawer();
    }

    function resetFilterAndSort() {
      document.querySelectorAll('.category-filter-checkbox').forEach(cb => {
        cb.checked = true;
      });

      updatePaddleSpecVisibility();

      const inStockCheckbox = document.getElementById('instock-only-checkbox');
      if (inStockCheckbox) inStockCheckbox.checked = false;

      // Reset Price Slider
      updatePriceSliderUI(0, maxScaleLimit);

      // Reset Paddle Core, Shape, and Vendor filters
      document.querySelectorAll('.paddle-core-checkbox').forEach(cb => { cb.checked = false; });
      document.querySelectorAll('.paddle-shape-checkbox').forEach(cb => { cb.checked = false; });
      document.querySelectorAll('.paddle-vendor-checkbox').forEach(cb => { cb.checked = false; });

      if (inlineSort) inlineSort.value = 'featured';

      applyFilterAndSort();
    }

    if (applyBtn) applyBtn.addEventListener('click', applyFilterAndSort);
    if (resetBtn) resetBtn.addEventListener('click', resetFilterAndSort);
  }

  window.initFilterAndSortDrawer = initFilterAndSortDrawer;

  // Initialize Filter & Sort Drawer
  initFilterAndSortDrawer();

  // Initial Cart Stepper Bind
  bindCartStepperButtons();

  // --- Back to Top Controller ---
  const backToTopBtn = document.getElementById('BackToTopBtn');
  if (backToTopBtn) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        backToTopBtn.classList.add('active');
      } else {
        backToTopBtn.classList.remove('active');
      }
    }, { passive: true });

    backToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // --- Quick View Controller ---
  const qvDrawer = document.getElementById('QuickViewDrawer');
  const qvOverlay = document.getElementById('QuickViewOverlay');
  const qvCloseBtn = document.getElementById('QuickViewClose');
  const qvLoading = document.getElementById('QuickViewLoading');
  const qvBody = document.getElementById('QuickViewBody');

  function openQuickView(handle) {
    if (!qvDrawer || !qvOverlay) return;

    qvDrawer.classList.add('active');
    qvOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    if (qvLoading) qvLoading.style.display = 'flex';
    if (qvBody) {
      qvBody.style.display = 'none';
      qvBody.innerHTML = '';
    }

    // Fetch product details via Shopify AJAX JSON endpoint
    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(product => {
        renderQuickViewProduct(product);
      })
      .catch(err => {
        console.error('Quick View Error:', err);
        if (qvLoading) qvLoading.style.display = 'none';
        if (qvBody) {
          qvBody.style.display = 'block';
          qvBody.innerHTML = `<div style="text-align: center; padding: 3rem 1rem;"><h3 style="font-family: var(--font-heading); color: #151515; font-size: 1.2rem; margin-bottom: 0.5rem; text-transform: uppercase;">Product Details</h3><p style="color: #71717a; font-size: 0.9rem; margin-bottom: 1.5rem;">Click below to view the full product page.</p><a href="/products/${handle}" class="qv-add-btn" style="text-decoration: none;">VIEW PRODUCT PAGE</a></div>`;
        }
      });
  }

  function closeQuickView() {
    if (qvDrawer) qvDrawer.classList.remove('active');
    if (qvOverlay) qvOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function renderQuickViewProduct(product) {
    if (!qvBody) return;
    if (qvLoading) qvLoading.style.display = 'none';
    qvBody.style.display = 'block';

    const activeCurr = getActiveCurrency();
    const firstVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
    const currentPriceCad = (firstVariant ? firstVariant.price : product.price) / 100;
    const formattedPrice = formatCurrencyString(currentPriceCad, activeCurr);
    const hasCompare = firstVariant && firstVariant.compare_at_price > firstVariant.price;
    const comparePriceCad = hasCompare ? firstVariant.compare_at_price / 100 : 0;
    const formattedCompare = hasCompare ? formatCurrencyString(comparePriceCad, activeCurr) : '';
    const featuredImg = product.featured_image || (product.images && product.images[0]) || '';

    let optionsHtml = '';
    if (product.options && product.options.length > 0 && product.variants.length > 1) {
      product.options.forEach((opt, optIdx) => {
        if (opt.name === 'Title' && opt.values.length === 1 && opt.values[0] === 'Default Title') return;
        optionsHtml += `
          <div class="qv-options-group">
            <label class="qv-option-label">${opt.name}: <span id="QvSelectedOpt-${optIdx}" style="color: #151515; font-weight: 900;">${opt.values[0]}</span></label>
            <div class="qv-pills">
              ${opt.values.map((val, valIdx) => `
                <button type="button" class="qv-pill ${valIdx === 0 ? 'active' : ''}" data-option-index="${optIdx}" data-value="${val}">
                  ${val}
                </button>
              `).join('')}
            </div>
          </div>
        `;
      });
    }

    qvBody.innerHTML = `
      <div class="qv-media-wrapper">
        <img id="QvFeaturedImg" src="${featuredImg}" alt="${product.title}" loading="lazy">
      </div>
      <div class="qv-vendor">${product.vendor || 'THE PICKLR'}</div>
      <h3 class="qv-title">${product.title}</h3>
      <div class="qv-price-row">
        <span class="qv-price" id="QvPrice" data-base-price="${currentPriceCad}">${formattedPrice}</span>
        ${hasCompare ? `<span class="qv-compare-price" id="QvComparePrice" data-base-price="${comparePriceCad}">${formattedCompare}</span>` : ''}
      </div>
      <div class="qv-shipping-notice">Taxes and <a href="/pages/shipping-faq" style="color: #151515; text-decoration: underline;">shipping calculated</a> at checkout</div>
      
      <form id="QvForm">
        <input type="hidden" name="id" id="QvVariantId" value="${firstVariant ? firstVariant.id : ''}">
        ${optionsHtml}
        <div class="qv-controls-row">
          <div class="qv-stepper">
            <button type="button" class="qv-step-btn" id="QvDecBtn">&#8722;</button>
            <span class="qv-step-qty" id="QvQtyVal">1</span>
            <button type="button" class="qv-step-btn" id="QvIncBtn">&#43;</button>
          </div>
          <button type="submit" class="qv-add-btn" id="QvAddToCartBtn">
            ${firstVariant && firstVariant.available ? 'ADD TO CART' : 'OUT OF STOCK'}
          </button>
        </div>
      </form>
      <a href="${product.url}" class="qv-view-full">VIEW FULL DETAILS &rarr;</a>
    `;

    // Bind option pills
    const pills = qvBody.querySelectorAll('.qv-pill');
    let selectedOptions = product.options.map(opt => opt.values[0]);

    pills.forEach(pill => {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        const optIdx = parseInt(this.getAttribute('data-option-index'), 10);
        const val = this.getAttribute('data-value');
        selectedOptions[optIdx] = val;

        const parentPills = this.parentElement.querySelectorAll('.qv-pill');
        parentPills.forEach(p => p.classList.remove('active'));
        this.classList.add('active');

        const labelSpan = document.getElementById(`QvSelectedOpt-${optIdx}`);
        if (labelSpan) labelSpan.textContent = val;

        // Find matching variant
        const matchedVariant = product.variants.find(v => {
          return selectedOptions.every((optVal, idx) => v.options[idx] === optVal);
        });

        if (matchedVariant) {
          const varInput = document.getElementById('QvVariantId');
          if (varInput) varInput.value = matchedVariant.id;

          const priceCad = matchedVariant.price / 100;
          const qvPriceEl = document.getElementById('QvPrice');
          if (qvPriceEl) {
            qvPriceEl.setAttribute('data-base-price', priceCad);
            qvPriceEl.textContent = formatCurrencyString(priceCad, activeCurr);
          }

          if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
            const featImg = document.getElementById('QvFeaturedImg');
            if (featImg) featImg.src = matchedVariant.featured_image.src;
          }

          const addBtn = document.getElementById('QvAddToCartBtn');
          if (addBtn) {
            if (matchedVariant.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'ADD TO CART';
              addBtn.style.opacity = '1';
              addBtn.style.cursor = 'pointer';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'OUT OF STOCK';
              addBtn.style.opacity = '0.5';
              addBtn.style.cursor = 'not-allowed';
            }
          }
        }
      });
    });

    // Bind stepper
    let qvQty = 1;
    const qvDec = document.getElementById('QvDecBtn');
    const qvInc = document.getElementById('QvIncBtn');
    const qvQtyVal = document.getElementById('QvQtyVal');

    if (qvDec) {
      qvDec.addEventListener('click', (e) => {
        e.preventDefault();
        if (qvQty > 1) {
          qvQty--;
          qvQtyVal.textContent = qvQty;
        }
      });
    }
    if (qvInc) {
      qvInc.addEventListener('click', (e) => {
        e.preventDefault();
        qvQty++;
        qvQtyVal.textContent = qvQty;
      });
    }

    // Bind form submission
    const qvForm = document.getElementById('QvForm');
    if (qvForm) {
      qvForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const variantId = document.getElementById('QvVariantId').value;
        const addBtn = document.getElementById('QvAddToCartBtn');
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'ADDING...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: qvQty }]
          })
        })
          .then(res => res.json())
          .then(() => {
            closeQuickView();
            if (window.openCartDrawer) {
              window.openCartDrawer();
            }
            if (window.refreshPicklrCart) {
              window.refreshPicklrCart();
            }
          })
          .catch(err => {
            console.error('Error adding to cart:', err);
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.textContent = 'ADD TO CART';
            }
          });
      });
    }
  }

  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;

  if (qvCloseBtn) qvCloseBtn.addEventListener('click', closeQuickView);
  if (qvOverlay) qvOverlay.addEventListener('click', closeQuickView);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeQuickView();
  });
});
